<script setup lang="ts">
import { ref } from 'vue';
import ExpandToggleButton from '@/_core/shared/ui/ExpandToggleButton/ExpandToggleButton.vue';

const props = withDefaults(
  defineProps<{
    maxHeight?: number;
    maxDesktopHeight?: number;
  }>(),
  {
    maxHeight: 150,
    maxDesktopHeight: 230,
  }
);

const isExpanded = ref(false);
</script>

<template>
  <div>
    <div
      class="tw:flex tw:items-start tw:justify-between tw:cursor-pointer"
      @click="isExpanded = !isExpanded"
    >
      <slot name="header" />
    </div>

    <div class="tw:relative">
      <div
        class="accordion-content"
        :class="{ expanded: isExpanded }"
        :style="{
          '--max-height': `${props.maxHeight}px`,
          '--max-desktop-height': `${props.maxDesktopHeight}px`,
        }"
      >
        <slot />
      </div>
      <div
        v-if="!isExpanded"
        class="tw:absolute tw:inset-x-0 tw:bottom-0 tw:h-12.5 tw:bg-linear-to-b tw:from-transparent tw:to-white tw:pointer-events-none"
      />
    </div>

    <div class="tw:mt-4 tw:flex tw:min-w-0 tw:items-center tw:justify-between tw:gap-4">
      <ExpandToggleButton class="tw:shrink-0" :value="isExpanded" @input="isExpanded = $event" />
      <div v-if="isExpanded" class="tw:flex tw:min-w-0 tw:flex-1 tw:justify-end">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.accordion-content {
  max-height: var(--max-height);
  overflow: hidden;
  transition: max-height 0.35s ease;

  @media (min-width: 1024px) {
    max-height: var(--max-desktop-height);
  }

  &.expanded {
    max-height: 2000px;
  }
}
</style>

<!-- Do NOT add anything else to this style block since it is NOT scoped -->
<style lang="scss">
.accordion-content {
  code {
    color: #3180f6;
  }
}
</style>
